import BasketProvider from './BasketProvider';

void new BasketProvider();
